import { render, staticRenderFns } from "./search-result.vue?vue&type=template&id=3ff491f2&scoped=true&"
import script from "./search-result.vue?vue&type=script&lang=ts&"
export * from "./search-result.vue?vue&type=script&lang=ts&"
import style0 from "./search-result.vue?vue&type=style&index=0&id=3ff491f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff491f2",
  null
  
)

export default component.exports